import { render, staticRenderFns } from "./SpaceAPI.vue?vue&type=template&id=0840d22c"
import script from "./SpaceAPI.vue?vue&type=script&lang=js"
export * from "./SpaceAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports